import { Injectable } from '@angular/core';
import { DOCUMENT_TAG_TYPE } from './document-tag-type.enum';
import { RequestItem } from './models/request-item.model';
import { TagType } from './models/tag-type.model';

@Injectable({
  providedIn: 'root'
})
export class ActionService {

  constructor() {}

  getSelectedOption(eventNode: any, orgId: string) {
    if (!eventNode || this.isBaseLevelTarget(eventNode)) {
      return {
        docTagItemId: orgId,
        docTagType: DOCUMENT_TAG_TYPE.ORGANIZATION,
        id: 'baseLevel',
        name: '',
      };
    }

    const association = eventNode?.data?.associations?.[0];
    const docTagItemId = association?.index ? association.index : orgId;
    const docTagType = association?.tagType ? association.tagType : DOCUMENT_TAG_TYPE.ORGANIZATION;
    return {
      docTagItemId: docTagItemId,
      docTagType: docTagType,
      id: eventNode.id,
      name: eventNode?.data?.path || '',
    };
  }

  getRequestItems(selectedParentNodes: any, selectedOption: any): RequestItem[] {
    let selectedPath = '';
    if (selectedOption.id !== 'baseLevel') {
      selectedPath = selectedOption.name;
    }
    const items = selectedParentNodes.map(node => {
      const targetNode = this.findRootNode(node, selectedParentNodes);
      const context = targetNode.data.documentKey.key;
      return {
        sourceDocumentKey: node.data.documentKey,
        context: context,
        targetPath: selectedPath
      };
    });
    return items;
  }

  findRootNode(node, selectedParentNodes) {
    if (node.parent) {
      if (selectedParentNodes.includes(node.parent) && node.parent.id !== 'ROOT_NODE_ID') {
        return this.findRootNode(node.parent, selectedParentNodes);
      } else {
        return node;
      }
    }
  }

  getDestinationTagType(selectedOption: any): TagType {
    return <TagType> {
      docTagItemId: selectedOption.docTagItemId,
      docTagType: selectedOption.docTagType
    };
  }

  validateDragMove(event) {
    const isBaseLevelTarget = this.isBaseLevelTarget(event?.overNode);
    const isFolderTarget = isBaseLevelTarget || event?.overNode?.data?.documentKey?.docType === 'PATH';
    const isDifferentParent = isBaseLevelTarget
      ? event?.node?.parent?.id !== 'ROOT_NODE_ID'
      : event?.node?.parent !== event?.overNode;

    return isFolderTarget &&
           isDifferentParent &&
           !event.node.allLeafChildren.includes(event.overNode);
  }

  private isBaseLevelTarget(node: any): boolean {
    return node?.id === 'baseLevel' || node?.id === 'ROOT_NODE_ID';
  }
}
